/**
 * @flow
 * @relayHash c8ba43951b58d929cc10eed17568f6cb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ConfigurableBlockEdit_viewer$ref = any;
export type configurableBlockPages_edit_QueryVariables = {|
  id: string
|};
export type configurableBlockPages_edit_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ConfigurableBlockEdit_viewer$ref
  |}
|};
export type configurableBlockPages_edit_Query = {|
  variables: configurableBlockPages_edit_QueryVariables,
  response: configurableBlockPages_edit_QueryResponse,
|};
*/


/*
query configurableBlockPages_edit_Query(
  $id: ID!
) {
  viewer {
    ...ConfigurableBlockEdit_viewer_1Bmzm5
    id
  }
}

fragment ConfigurableBlockEdit_viewer_1Bmzm5 on Viewer {
  ...ArticleSelector_viewer
  id
  configurableBlock(id: $id) {
    id
    type
    slug
    active
    config
  }
}

fragment ArticleSelector_viewer on Viewer {
  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {
    articles {
      id
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "configurableBlockPages_edit_Query",
  "id": null,
  "text": "query configurableBlockPages_edit_Query(\n  $id: ID!\n) {\n  viewer {\n    ...ConfigurableBlockEdit_viewer_1Bmzm5\n    id\n  }\n}\n\nfragment ConfigurableBlockEdit_viewer_1Bmzm5 on Viewer {\n  ...ArticleSelector_viewer\n  id\n  configurableBlock(id: $id) {\n    id\n    type\n    slug\n    active\n    config\n  }\n}\n\nfragment ArticleSelector_viewer on Viewer {\n  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {\n    articles {\n      id\n      title\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "configurableBlockPages_edit_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ConfigurableBlockEdit_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "configurableBlockPages_edit_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "articlesForSelector",
            "name": "articlesPaginate",
            "storageKey": "articlesPaginate(hidden:false,page:1,pageSize:5)",
            "args": [
              {
                "kind": "Literal",
                "name": "hidden",
                "value": false,
                "type": "Boolean"
              },
              {
                "kind": "Literal",
                "name": "page",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 5,
                "type": "Int"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "configurableBlock",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": "ID"
              }
            ],
            "concreteType": "ConfigurableBlock",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "slug",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "active",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "config",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2dc73fe8906a719697bc8f1485470d1e';
module.exports = node;



// WEBPACK FOOTER //
// src/components/configurable-blocks/__generated__/configurableBlockPages_edit_Query.graphql.js